import { createFileRoute, redirect } from "@tanstack/react-router";

import {
  DEFAULT_DISPLAYED_PROPERTIES,
  DEFAULT_GROUP_BY,
  DEFAULT_SORT,
} from "~/validators/search-tickets-validator";

export const Route = createFileRoute("/_auth/_app_shell/_main-navigation/")({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: "/tickets/todo",
      search: {
        sort: DEFAULT_SORT,
        groupBy: DEFAULT_GROUP_BY,
        displayedProperties: DEFAULT_DISPLAYED_PROPERTIES,
      },
    });
  },
});
